export enum EmailPriority {
    Low = "Low",
    Normal = "Normal",
    High = "High",
}

export default EmailPriority;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/client/resources/emailPriority.ts